module.exports = __webpack_public_path__ + "static/lowes-c19733f99f9fbc316784035c7e492f16.png";